module.exports = __webpack_public_path__ + "img/img-5.7c5342ba.jpg";